import React from 'react'
import Dimensions from '../../dimensions/pill-list'

const UserGoalDetails = ({
    userGoal = {},
}) => {

    return (
        <div>
            <div className='text-muted'>
                {userGoal.content}
            </div>
            <div>
                <Dimensions dimensions={userGoal.dimensions} />
            </div>
        </div>
    )
}

export default UserGoalDetails